import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useStellarApiClient } from "@hooks/use-stellar-api-client";
/** Key used to store the latest article identifier in local storage */
export const LATEST_WHATS_NEW_ARTICLE_KEY = "latestWhatsNewArticle";
/**
 * Hook to check for new articles in the "What's New" section.
 * It fetch the base64 encoded URL of the latest article and compares it with a stored value in local storage.
 * If they differ or value is not available in local storage, it indicates that there are new articles available.
 *
 * @returns An object containing the latest article identifier and a function to update it.
 */
export function useCheckWhatsNew() {
  const $ = _c(5);
  const [newArticle, setNewArticle] = useState(undefined);
  const {
    stellarApiClient
  } = useStellarApiClient();
  let t0;
  let t1;
  if ($[0] !== stellarApiClient.productUpdate) {
    t0 = () => {
      const fetchLatestArticle = async function fetchLatestArticle() {
        ;
        try {
          const response = await stellarApiClient.productUpdate.getNewUpdate();
          if (!response.latestArticle) {
            return;
          }
          const latestArticle = response.latestArticle;
          const storedArticle = localStorage.getItem(LATEST_WHATS_NEW_ARTICLE_KEY);
          if (storedArticle !== latestArticle) {
            setNewArticle(latestArticle);
          }
        } catch (t2) {
          const _ = t2;
        }
      };
      fetchLatestArticle();
    };
    t1 = [stellarApiClient.productUpdate];
    $[0] = stellarApiClient.productUpdate;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== newArticle) {
    t2 = {
      newArticle,
      setNewArticle
    };
    $[3] = newArticle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}